var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { preact } from "survey-js-ui";
// eslint-disable-next-line surveyjs/no-imports-from-entries
import { SurveyCreatorComponent, SurveyCreator as SurveyCreatorReact } from "../../survey-creator-react/src/entries/index";
export function renderSurveyCreator(creator, element, props) {
    if (props === void 0) { props = {}; }
    var node = element;
    if (typeof element === "string") {
        node = document.getElementById(element);
    }
    var survey = preact.createElement(SurveyCreatorComponent, __assign({ creator: creator }, props));
    preact.render(survey, node);
}
var SurveyCreator = /** @class */ (function (_super) {
    __extends(SurveyCreator, _super);
    function SurveyCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyCreator.prototype.render = function (target) {
        renderSurveyCreator(this, target);
    };
    return SurveyCreator;
}(SurveyCreatorReact));
export { SurveyCreator };
if (typeof window !== "undefined") {
    var jQuery_1 = window["jQuery"] || window["$"];
    if (!!jQuery_1) {
        jQuery_1["fn"].extend({
            SurveyCreator: function (props) {
                return this.each(function () {
                    renderSurveyCreator(props.model, this, props);
                });
            },
        });
    }
}
